// extracted by mini-css-extract-plugin
export default {"container":"_107i_","entry":"_3PhCA","error":"_2lZfI","name":"_1dMZi","amount":"_1BOVN"};